var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 21,
    fill: "none",
    viewBox: "0 0 32 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    d: "M13.12 18.068a.996.996 0 0 1-1.408 1.408L.792 8.555a.995.995 0 0 1 1.407-1.408z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    d: "M29.046.792a.995.995 0 0 1 1.408 1.407L13.561 19.093a.996.996 0 0 1-1.408-1.408z"
  })));
};
export default SvgCheckmark;